/* unplugin-vue-components disabled */import script from "./YExport.vue?vue&type=script&setup=true&lang=tsx"
export * from "./YExport.vue?vue&type=script&setup=true&lang=tsx"

const __exports__ = script;

export default __exports__